import { useEspot } from '@app/hooks';
import {
  CMC_ESPOT_PCC_FOOTER_LOGO,
  CMC_ESPOT_PCC_FOOTER_PHU_THAI
} from '../constants';
import Espot from '@app/components/common/Espot/Espot';
import styles from './FooterPaymentShippingEspot.module.scss';

const FooterPaymentShippingEspot = () => {
  const eSpotNames = [
    CMC_ESPOT_PCC_FOOTER_PHU_THAI,
    CMC_ESPOT_PCC_FOOTER_LOGO
  ].join(',');
  const { getEspotContent } = useEspot(eSpotNames);
  const addressEspotContent = getEspotContent(CMC_ESPOT_PCC_FOOTER_PHU_THAI);
  const dealerLegalLogo = getEspotContent(CMC_ESPOT_PCC_FOOTER_LOGO);
  return (
    <div className={`${styles['footer-espot-container--border']} row g-0`}>
      <div className="col-12 col-blg-9">
        <Espot html={addressEspotContent} />
      </div>
      <div className="col-12 col-blg-3">
        <Espot html={dealerLegalLogo} />
      </div>
    </div>
  );
};

export default FooterPaymentShippingEspot;
